import { render, staticRenderFns } from "./BoletinView.vue?vue&type=template&id=07405946&scoped=true&"
import script from "./BoletinView.vue?vue&type=script&lang=js&"
export * from "./BoletinView.vue?vue&type=script&lang=js&"
import style0 from "./BoletinView.vue?vue&type=style&index=0&id=07405946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07405946",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VCard,
  VCardText,
  VCardTitle,
  VContainer,
  VDivider,
  VFlex,
  VLayout,
  VProgressCircular,
  VSubheader,
  VToolbar,
  VToolbarTitle,
})
